/**
 * Me IA v2 — 「我的」primary owner（FE-IA-V2-04）。
 * Canonical：Profile／收藏／個人地圖／VIP／Settings。
 * 不合併 backend；不造假 VIP checkout 或 Saved location filter。
 */

export const ME_IA_CAPABILITIES = Object.freeze({
  profile: 'EXISTING',
  saved: 'EXISTING',
  savedJourneys: 'EXISTING',
  savedPosts: 'EXISTING',
  savedLocations: 'NOT_AVAILABLE',
  personalMap: 'EXISTING',
  vipPage: 'NOT_AVAILABLE',
  vipEntitlementDisplay: 'EXISTING_CONTEXTUAL', // Host Group Trip 等既有面
  settingsPage: 'NOT_AVAILABLE',
  settingsPrivacy: 'EXISTING',
  settingsAgreement: 'EXISTING',
  settingsBlockedMembers: 'EXISTING',
  profileEditDialog: 'EXISTING',
  profileEditRoute: 'NOT_AVAILABLE',
});

export const ME_IA_CANONICAL = Object.freeze([
  {
    id: 'profile',
    kind: 'link',
    resolveTo: 'ownProfile',
    labelKey: 'travel.nav.profile',
    testId: 'me-link-profile',
    capability: ME_IA_CAPABILITIES.profile,
  },
  {
    id: 'saved',
    kind: 'link',
    to: '/saved',
    labelKey: 'travel.nav.saved',
    testId: 'me-link-saved',
    capability: ME_IA_CAPABILITIES.saved,
  },
  {
    id: 'personal-map',
    kind: 'link',
    to: '/me/personal-map',
    labelKey: 'travel.nav.personalMap',
    hintKey: 'travel.nav.personalMapHint',
    testId: 'me-link-personal-map',
    capability: ME_IA_CAPABILITIES.personalMap,
  },
  {
    id: 'vip',
    kind: 'unavailable',
    labelKey: 'travel.me.vip.title',
    hintKey: 'travel.me.vip.unavailableHint',
    testId: 'me-link-vip',
    capability: ME_IA_CAPABILITIES.vipPage,
  },
  {
    id: 'settings',
    kind: 'section',
    labelKey: 'travel.me.settings.title',
    testId: 'me-settings',
    capability: ME_IA_CAPABILITIES.settingsBlockedMembers,
  },
]);

/**
 * OLD_ROUTE → IA_V2_OWNER → CANONICAL_DESTINATION → COMPATIBILITY_ACTION
 */
export const ME_IA_ROUTE_COMPATIBILITY = Object.freeze([
  {
    oldRoute: '/me',
    owner: 'me',
    destination: '/me',
    action: 'KEEP_AS_PRIMARY',
  },
  {
    oldRoute: '/saved',
    owner: 'me',
    destination: '/saved',
    action: 'KEEP_UNDER_ME',
  },
  {
    oldRoute: '/saved-journeys',
    owner: 'me',
    destination: '/saved?contentType=JOURNEY_PUBLICATION',
    action: 'KEEP_REDIRECT',
  },
  {
    oldRoute: '/social/creators/:memberId',
    owner: 'profile',
    destination: '/social/creators/:memberId',
    action: 'KEEP_PUBLIC_AND_OWN',
  },
  {
    oldRoute: '/social/creators/:memberId (edit dialog)',
    owner: 'me',
    destination: 'CreatorProfileEditDialog',
    action: 'KEEP_IN_PAGE_EDIT',
  },
  {
    oldRoute: '/me/personal-map',
    owner: 'me',
    destination: '/me/personal-map',
    action: 'KEEP',
  },
  {
    oldRoute: '/privacy-policy',
    owner: 'me.settings',
    destination: '/privacy-policy',
    action: 'KEEP_RELATED',
  },
  {
    oldRoute: '/agreement',
    owner: 'me.settings',
    destination: '/agreement',
    action: 'KEEP_RELATED',
  },
]);

export function selfCreatorPath(user) {
  const id = user?.memberId ?? user?.id;
  if (id == null || id === '') return null;
  const text = String(id);
  if (!/^[1-9]\d*$/.test(text)) return null;
  return `/social/creators/${text}`;
}
